interface TopBarProps {
  title?: string
}

export default function TopBar({ title }: TopBarProps) {
  return (
    <div
      className="chat-header"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '11px 22px 11px 52px',
        borderBottom: '1px solid var(--bd)',
        background: 'var(--white)',
        boxShadow: 'var(--sh-sm)',
        flexShrink: 0,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
        <span style={{ fontSize: 14.5, fontWeight: 500, color: 'var(--text)' }}>
          {title || 'New conversation'}
        </span>
        <span
          className="hide-mobile"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            background: 'var(--gold-lt)',
            border: '1px solid var(--gold-bd)',
            borderRadius: 100,
            padding: '3px 9px',
            fontSize: 9.5,
            fontWeight: 600,
            color: 'var(--gold)',
            letterSpacing: '1px',
            textTransform: 'uppercase',
          }}
        >
          ✦ Beta
        </span>
      </div>
    </div>
  )
}
